module.exports = __webpack_public_path__ + "img/291b5ccba3708665eeecc427fafd6da.fdb4d5ff.png";